module.exports = __webpack_public_path__ + "static/img/h6-2.057acb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h6-2.png
// module id = 57/K
// module chunks = 1